import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const ChangePassword = ({ user, onBack }) => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const validatePassword = () => {
        if (!newPassword || newPassword.trim() === "") {
            setError("La nueva contraseña no puede estar vacía");
            return false;
        }
        if (newPassword.length < 6) {
            setError("La nueva contraseña debe tener al menos 6 caracteres");
            return false;
        }
        if (newPassword !== confirmPassword) {
            setError("Las contraseñas no coinciden");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!validatePassword()) {
            return;
        }

        setIsLoading(true);

        try {
            const response = await axios.post(
                //"https://helpharmadomicilios.cielum.co/webhook-test/PRO-4470fd9c-fa9b-4677-8436-ced0bb8c23c5", //test
                "https://helpharmadomicilios.cielum.co/webhook/PRO-4470fd9c-fa9b-4677-8436-ced0bb8c23c5", //produccion
                {
                    correo: user.email,
                    nueva_password: newPassword
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    auth: {
                        username: "DOMICILIOSAPI_operador_logistico",
                        password: "DOMICILIOSAPI_operador_logistico"
                    }
                }
            );

            const data = response.data;

            if (data && (data.error === 1 || data.error === "1")) {
                throw new Error(data.message || "Error al cambiar la contraseña");
            }

            setSuccess("¡Contraseña cambiada exitosamente! Por seguridad, te recomendamos cerrar sesión y volver a iniciar con tu nueva contraseña.");
            setNewPassword("");
            setConfirmPassword("");

        } catch (err) {
            console.error("Error al cambiar contraseña:", err);
            let msg = err.message || "Error en el servidor";
            if (err.response && err.response.data && err.response.data.message) {
                msg = err.response.data.message;
            }
            setError(msg);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="main-content" style={{ maxWidth: '520px', margin: '2rem auto' }}>
            <div className="glass-card" style={{ padding: '2rem' }}>
                <div style={{
                    background: 'linear-gradient(135deg, rgba(0, 51, 160, 0.5), rgba(74, 144, 217, 0.3))',
                    borderRadius: 'var(--radius-md) var(--radius-md) 0 0',
                    margin: '-2rem -2rem 1.5rem',
                    padding: '1.5rem 2rem',
                    borderBottom: '1px solid var(--border-glass)'
                }}>
                    <h4 style={{ margin: 0, fontWeight: 700, color: 'white' }}>🔒 Cambiar Contraseña</h4>
                </div>

                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="input-group-premium">
                        <label className="input-label">Nueva Contraseña</label>
                        <span className="input-icon">🔑</span>
                        <input
                            type="password"
                            className="form-control input-premium"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            disabled={isLoading}
                            placeholder="Mínimo 6 caracteres"
                        />
                    </div>

                    <div className="input-group-premium">
                        <label className="input-label">Confirmar Nueva Contraseña</label>
                        <span className="input-icon">🔑</span>
                        <input
                            type="password"
                            className="form-control input-premium"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            disabled={isLoading}
                            placeholder="Repite la nueva contraseña"
                        />
                    </div>

                    <div className="d-grid gap-2" style={{ marginTop: '1.5rem' }}>
                        <button
                            type="submit"
                            className="btn btn-premium"
                            disabled={isLoading}
                        >
                            {isLoading
                                ? <><span className="spinner-premium"></span>Cambiando...</>
                                : "Cambiar Contraseña"
                            }
                        </button>
                        <button
                            type="button"
                            className="btn btn-glass"
                            onClick={onBack}
                            disabled={isLoading}
                        >
                            ← Volver
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
